import { IconName } from 'src/components/ui/Icon/Icon';
import { OptionItemAccessory, OptionItemProps } from 'src/components/ui/OptionItem/OptionItem';

enum BadgeType {
  Neutral = 'neutral',
  Successful = 'succesful',
  Warning = 'warning',
  Error = 'error',
  Neutral2 = 'neutral2',
  Neutral3 = 'neutral3',
  Neutral4 = 'neutral4',
  Neutral5 = 'neutral5',
}

export const menuItems = [
  {
    link: 'dashboard',
    icon: 'space-dashboard' as IconName,
    label: 'navbar.dashboard',
    section: 'navbar.section_operations',
  },
  {
    link: 'warehouse/inventory',
    icon: 'warehouse' as IconName,
    label: 'navbar.inventory',
    section: 'navbar.section_operations',
    badgeId: 'product_product',
    badgeType: BadgeType.Warning,
  },
  {
    link: 'warehouse/inbound',
    icon: 'inbound' as IconName,
    label: 'navbar.inbound',
    section: 'navbar.section_operations',
  },
  {
    link: 'outbound',
    icon: 'local-shipping' as IconName,
    label: 'navbar.outbound',
    section: 'navbar.section_operations',
    badgeId: 'sale_order',
    badgeType: BadgeType.Warning,
  },
  {
    link: 'returns',
    icon: 'returns' as IconName,
    label: 'navbar.returns',
    section: 'navbar.section_operations',
    badgeType: BadgeType.Warning,
  },
  {
    link: 'forecasts',
    icon: 'bar-chart' as IconName,
    label: 'navbar.forecasts',
    section: 'navbar.section_operations',
  },
  {
    link: 'cases',
    icon: 'note' as IconName,
    label: 'navbar.cases',
    section: 'navbar.section_support',
    badgeId: 'project_task',
    badgeType: BadgeType.Warning,
  },
  {
    link: 'cases/claims',
    icon: 'warning' as IconName,
    label: 'navbar.cases_claims',
    section: 'navbar.section_support',
  },
  {
    link: 'ai-chat',
    icon: 'ai-chat' as IconName,
    label: 'navbar.ai-chat',
    section: 'navbar.section_support',
  },
  {
    link: 'advanced-reports',
    icon: 'bar-chart' as IconName,
    label: 'navbar.advanced_reports',
    section: 'navbar.section_insights',
  },
  {
    link: 'statistics',
    icon: 'bar-chart' as IconName,
    label: 'navbar.statistics',
    section: 'navbar.section_insights',
  },
  {
    link: 'carrier-analytics/dashboard',
    icon: 'space-dashboard' as IconName,
    label: 'navbar.dashboard',
    section: 'navbar.section_carrier',
  },
  {
    link: 'carrier-analytics/countries-and-groups',
    icon: 'public' as IconName,
    label: 'navbar.countries_and_groups',
    section: 'navbar.section_carrier',
  },
  {
    link: 'carrier-analytics/carrier-list',
    icon: 'package' as IconName,
    label: 'navbar.carrier_list',
    section: 'navbar.section_carrier',
  },
  // --- Tools ---
  {
    link: 'integrations',
    icon: 'integrations' as IconName,
    label: 'navbar.integrations',
    section: 'navbar.section_tools',
    childs: [
      {
        link: 'integrations/dashboard',
        label: 'navbar.dashboard',
      },
      {
        link: 'integrations/connectors',
        label: 'navbar.all_integrations',
      },
      {
        link: 'integrations/mappings',
        label: 'navbar.mappings',
      },
    ],
  },
  {
    link: 'workflows',
    icon: 'account-tree' as IconName,
    label: 'navbar.workflows',
    section: 'navbar.section_tools',
  },
];

export const menuOverlayItemsFirstSection = [
  {
    link: 'settings?tab=company',
    accessory: OptionItemAccessory.Icon,
    accessoryItem: 'company',
    label: 'navbar.company',
  },
  {
    link: 'settings?tab=my_profile',
    accessory: OptionItemAccessory.Icon,
    accessoryItem: 'profile',
    label: 'navbar.profile',
  },
  {
    link: 'invoices',
    accessory: OptionItemAccessory.Icon,
    accessoryItem: 'conditions',
    label: 'navbar.invoices',
  },
  // {
  //   link: '404',
  //   accessory: OptionItemAccessory.Icon,
  //   accessoryItem: 'public',
  //   label: 'navbar.public',
  // },
  // {
  //   link: 'channels',
  //   accessory: OptionItemAccessory.Icon,
  //   accessoryItem: 'channels',
  //   label: 'navbar.channels',
  // },
  {
    link: '',
    accessory: OptionItemAccessory.Icon,
    accessoryItem: 'notifications',
    label: 'navbar.notifications',
  },
  // {
  //   link: 'conditions',
  //   accessory: OptionItemAccessory.Icon,
  //   accessoryItem: 'conditions',
  //   label: 'navbar.conditions',
  // },
] as OptionItemProps[];

export const menuOverlayItemsSecondSection = [
  {
    link: '',
    label: 'navbar.terms_and_conditions',
    type: 'terms',
  },
  {
    link: '',
    label: 'navbar.privacy_policy',
    type: 'policy',
  },
  {
    link: '',
    label: 'Weship',
    type: 'version',
    disabled: true,
  },
];
